import { Card } from "waapi/waap-ui/components/Card/Card.js";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import styled from "styled-components";

export const StyledContainer = styled(Flex)``;

export const StyledCardBody = styled(Card)`
    box-shadow: ${(props) => props.theme.shadows.card.default};
    padding: ${({ theme }) => theme.spacing["12"]};
    border-radius: ${(props) => props.theme.radius.m};
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing["16"]};
`;

export const StyledText = styled(Text)``;

export const StyledTextContainer = styled(Flex)``;

export const StyledHeaderBody = styled(Flex)``;

export const SvgContainer = styled(Flex)``;
